import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'
Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    theme: {
        themes: {
            light: {
                primary: "#119DA4",
                secondary: "#171b34",
                accent: "3D87E4",
                white: "#ffffff",
                orange: '#d28b53',
                red: '#F44336',
                bluegrey: '#CFD8DC',
                sp_grey: '#e5e5e5e5'
            }
        }
    }
});
